import { render, staticRenderFns } from "./Bildungsliste.vue?vue&type=template&id=c9ec23e2"
import script from "./Bildungsliste.vue?vue&type=script&lang=js"
export * from "./Bildungsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports